import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    profile: {"isAuthenticated":false,"token":"","user":{"id":0,"name":"","email":"","last_activity":"","finyear":0,"company":{"id":0,"type":0,"status":"Active","name":"","street":"","city":"","pin":"","gstin":"","tel":"","mobile":"","email":"","web":"","state_cd":33,"landmark":""},"branch":{"id":0,"type":0,"status":"Active","name":"","street":"","city":"","pin":"","gstin":"","tel":"","mobile":"","email":"","web":"","state_cd":33,"cmp_id":0,"landmark":"","company":{"id":0,"type":0,"status":"Active","name":"","street":"","city":"","pin":"","gstin":"","tel":"","mobile":"","email":"","web":"","state_cd":33,"landmark":""}},"department":{"id":1,"status":"Active","name":""}}},
    user: {"id":0,"name":"","email":"","last_activity":"","finyear":0,"company":{"id":0,"type":0,"status":"Active","name":"","street":"","city":"","pin":"","gstin":"","tel":"","mobile":"","email":"","web":"","state_cd":33,"landmark":""},"branch":{"id":0,"type":0,"status":"Active","name":"","street":"","city":"","pin":"","gstin":"","tel":"","mobile":"","email":"","web":"","state_cd":33,"cmp_id":0,"landmark":"","company":{"id":0,"type":0,"status":"Active","name":"","street":"","city":"","pin":"","gstin":"","tel":"","mobile":"","email":"","web":"","state_cd":33,"landmark":""}},"department":{"id":1,"status":"Active","name":""}},
    token: '',
  },
  actions: {
    login () {
      console.log('store->state->login');
    }
  },
  mutations: {
    change(state, profile) {
      console.log('change');
      state.profile = profile
    }
  },
  getters: {
    profile: state => state.profile
  }
})
